import sample_1 from './basics-business.jpg';

export const basicsBusinessImpressions = {
    sample_1,
};
